import { createSlice } from "@reduxjs/toolkit";

const mymarket = [];
const mymarketforGroup = [];
const mymarketResponse = [];
const marketLoading = false;
const downloading = null;

const MyMarketSlice = createSlice({
  name: "MyMarket",
  initialState: {
    mymarket,
    mymarketforGroup,
    mymarketResponse,
    marketLoading,
    downloading
  },
  reducers: {
    reSetMyMarket(state, action){
      state.mymarket = [];
      state.mymarketResponse = [];
      state.marketLoading = false;
      state.downloading = null;
    },
    setMyMarket(state, action) {
      state.mymarket = action.payload;
    },
    setMyMarketResponse(state, action) {
      state.mymarketResponse = action.payload;
    },
    setMarketLoading(state, action) {
      state.marketLoading = action.payload
    }, 
    setDownloading(state, action) {
        state.downloading = action.payload;
    },
    setMyMarketForGroup(state, action) {
      state.mymarketforGroup = action.payload;
    },
    // Only the account's visualized-shop count; the loaded list, its paging and the filter stay as they are
    setVisCount(state, action) {
      if (state.mymarket && !Array.isArray(state.mymarket)) state.mymarket.visCount = action.payload;
    }
  },
});

export const { setMyMarket, setMyMarketResponse, setMarketLoading, setDownloading,reSetMyMarket, setMyMarketForGroup, setVisCount } = MyMarketSlice.actions;

export default MyMarketSlice.reducer;
